<template>
  <div class="big-box">
    <img :src="backgroundImage" alt="" class="big-box-img" />
    <div class="big-body">
      <div class="pd8">
        <img
          src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260204/8b0fbc03853344baa32e5d64970edc6c.png"
          alt=""
          class="tap-top"
        />
        <!-- 主题文字 -->
        <div class="theme-word" :style="`color: ${customerPaperwork.titleColor};`">
          <span>{{ customerPaperwork.title }}</span>
          <span>{{ customerPaperwork.desc }}</span>
        </div>
        <!-- 祝福 -->
        <div class="fifthPicture">
          <img :src="bannerUrl" />
          <div class="fifthPictureText" v-html="ruleForm.blessingText"></div>
          <div class="form">
            <span>From：店铺名称</span>
          </div>
        </div>
        <!-- 音效 -->
        <div class="mp3" v-if="customerPaperwork.rgb4=='1'">
          <img
            src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260205/953baeba3ff5420f8a17a6b266509f3d.png"
            v-if="customerPaperwork.rgb3 == '1'"
          />
          <img
            src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260205/3ec3c785948d460a879876513d375876.png"
            v-else
          />
        </div>
        <!-- 底部奖品栏目 -->
        <div class="bottomDom">
          <div class="prizeBody">
            <div class="prizeTitle">
              <span>登记生日有机会抽以下奖品</span>
            </div>
            <!-- 有效期 -->
            <div class="validityPeriod">
              {{ timeType }}
            </div>
            <!-- 奖品 -->
            <div class="prizeList">
              <template v-for="(item, index) in prizeSettingList">
                <img :key="index" :src="item.logo" v-if="item.logo" />
              </template>
            </div>
          </div>
          <div
            class="btnDom"
            :style="`background-image: url(${btnUrl});color: ${customerPaperwork.rgb};`"
          >
            <span>领取奖品</span>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    prizeSettingList: {
      type: Array,
      default: () => [],
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      prizeList: [],
      tapTopUrl: "https://cdn-image.yucrm.cn/images/dyAssets/images/images/preview/shop_top.png",
      inviteNumImg: "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/yqrs_footer.png",
    };
  },
  computed: {
    timeType() {
      if (this.ruleForm.timeType === 'day') {
        return "生日当天";
      } else if (this.ruleForm.timeType === 'week') {
        return "生日当周";
      } else if (this.ruleForm.timeType === 'month') {
        return "生日当月";
      }
    },
    bannerUrl() {
      return this.customerPaperwork.url2 ? this.customerPaperwork.url2 : this.templateObj.url2;
    },
    btnUrl() {
      return this.customerPaperwork.url3 ? this.customerPaperwork.url3 : this.templateObj.url3;
    }
  },
  watch: {
    prizeSettingList: {
      handler(newVal) {
        let arr = newVal;
        this.prizeList = arr.filter((item) => item.logo);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;
  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 564px;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .pd8 {
      width: 100%;
      height: 100%;
      padding: 8px;
      box-sizing: border-box;
      position: relative;
      .tap-top {
        width: 100%;
      }
      .theme-word {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 72px;
        width: 100%;
        > span:first-child {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 10px;
        }
        > span:last-child {
          font-size: 10px;
        }
      }
      .fifthPicture {
        position: absolute;
        width: 203px;
        top: 180px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        > img {
          width: 203px;
          height: 113px;
          margin-bottom: 11px;
          border-radius: 10px;
        }
        .fifthPictureText {
          font-weight: 400;
          font-size: 17px;
          color: #9e5e4b;
          line-height: 19px;
          width: 203px;
          height: 56px;
          overflow: auto;
          // 文字自动换行
          word-break: break-word;
          font-family: "pingfangshaohua";
          // 隐藏滚动条
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .form {
          width: 203px;
          text-align: right;
          font-weight: 400;
          font-size: 11px;
          color: rgba(0, 0, 0, 0.6);
          margin-top: 13px;
        }
      }
      .mp3 {
        width: 22px;
        height: 22px;
        position: absolute;
        top: 80px;
        left: 17px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      .bottomDom {
        position: absolute;
        top: 408px;
        left: 50%;
        transform: translateX(-50%);
        .prizeBody {
          width: 263px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 5px 5px 5px 5px;
          border: 0px solid rgba(255, 255, 255, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          .prizeTitle {
            background-image: url("https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260205/d65bd6c9be844ad78b1e8015e17ff824.png");
            width: fit-content;
            height: 16px;
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            padding: 0 15px;
            line-height: 16px;
            font-weight: 400;
            font-size: 8px;
            color: #ffffff;
          }
          .validityPeriod {
            margin: 5px;
            font-weight: 400;
            font-size: 8px;
            color: rgba(255, 255, 255, 0.5);
          }
          .memberList {
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            padding-left: 10px;
            margin-bottom: 8px;
            > div {
              font-weight: 400;
              font-size: 8px;
              color: rgba(255, 238, 209, 0.5);
              border-bottom: 2px solid transparent;
              margin-right: 15px;
              // 文字不换行
              white-space: nowrap;
              > div {
                width: 100%;
                height: 2px;
                border-radius: 100px;
                margin-top: 4px;
              }
              .active {
                background: linear-gradient(
                  90deg,
                  rgba(255, 238, 209, 1),
                  rgba(255, 238, 209, 0)
                );
              }
            }
            > div:first-child {
              font-weight: bold;
              font-size: 8px;
              color: #ffeed1;
            }
          }
          .prizeList {
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            padding-left: 10px;
            margin-bottom: 8px;
            > img {
              width: 38px;
              height: 38px;
              border-radius: 3px 3px 3px 3px;
              margin-right: 8px;
            }
          }
        }
        .btnDom {
          margin: 0 auto;
          width: 181px;
          height: 38px;
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          font-weight: bold;
          font-size: 15px;
          text-align: center;
          line-height: 38px;
          margin-top: 20px;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }
    }
    .action {
      position: absolute;
      top: 310px;
      width: 100%;
      height: 100px;
      text-align: center;
      .info {
        font-weight: 400;
        font-size: 10px;
        color: #ffffff;
        line-height: 10px;
        text-align: center;
      }
      .btn {
        margin: 8px auto;
        position: relative;
        width: 144px;
        height: 29px;
        border-radius: 25px;
        .btn-bg {
          width: 100%;
          height: 100%;
          border-radius: 25px;
        }
        &-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: 500;
          font-size: 12px;
          color: #343229;
          text-align: center;
        }
      }
    }
    .goods {
      box-sizing: border-box;
      position: absolute;
      top: 380px;
      left: 50%;
      width: 250px;
      height: 220px;
      transform: translate(-50%, 0);
      background: rgba(255, 255, 255, 0.6);
      box-shadow: 4px 0px 4px 0px rgba(201, 160, 166, 0.3);
      border-radius: 12px;
      border: 1px solid #ffffff;
      padding: 14px 0 0 14px;
      overflow-x: auto;
      overflow-y: hidden;
      &-top {
        margin-top: 14px;
        width: 80%;
        margin-left: 16px;
        position: relative;
        .line {
          width: 100%;
          border: 1px dashed #fd97ac;
        }
        .btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 65px;
          height: 17px;
          text-align: center;
          line-height: 15px;
          background: #f75073;
          font-size: 10px;
          color: #ffffff;
          border-radius: 50px;
        }
      }
      &-time {
        margin-top: 16px;
        margin-right: 20px;
        font-weight: 400;
        font-size: 10px;
        color: #2d2f31;
        line-height: 10px;
        text-align: center;
      }
      &-style {
        margin-top: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        width: 238px;
        .item {
          position: relative;
          flex-shrink: 0;
          margin-right: 14px;
          width: 95px;
          height: 120px;
          padding: 7px 11px;
          border-radius: 6px;
          text-align: center;
          background: url("https://cdn-image.yucrm.cn/images/dyAssets/images/preview/goods.png") no-repeat;
          background-size: 125px 159px;
          &-url {
            width: 73px;
            height: 73px;
            border-radius: 8px;
          }
          &-title {
            margin: 10px 0 7px;
            font-weight: 400;
            font-size: 13px;
            color: #2d2f31;
            line-height: 13px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          &-num {
            font-weight: 400;
            font-size: 11px;
            color: #999999;
            line-height: 11px;
          }
        }
      }
      &-item {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        // height: 100%;
      }
      .onetwo-style {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .more-activity {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 125px;
    right: 6px;
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
@font-face {
  font-family: "pingfangshaohua";
  src: url("../../../../../assets/font/pingfangshaohua.woff2")
    format("woff2");
  font-weight: normal;
  font-style: normal;
}
</style>
